import request from "@/utils/request";
import { getCommunityId } from "@/api/community/communityApi";

// 查询资金支付列表
export function queryFundPayments(params) {
  return new Promise((resolve, reject) => {
    // 自动补充小区ID（与房屋接口保持一致）
    const communityId = getCommunityId();
    request({
      url: "/fee.listFundPaymentCmd",
      method: "get",
      params: {
        ...params,
        communityId,
      },
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 获取资金支付详情
export function getFundPaymentDetail(params) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId();
    request({
      url: "/fee.getFundPaymentDetail",
      method: "get",
      params: {
        ...params,
        communityId,
      },
    })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 新增资金支付
export function addFundPayment(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId();
    request({
      url: "/fee.saveFundPaymentCmd",
      method: "post",
      data: {
        ...data,
        communityId,
      },
    })
      .then((response) => {
        const res = response.data;
        // 统一错误处理（参考已售房屋接口风格）
        if (res.code === 0) {
          resolve(res);
        } else {
          reject(new Error(res.msg || "新增资金支付失败"));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 修改资金支付
export function updateFundPayment(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId();
    request({
      url: "/fee.updateFundPaymentCmd",
      method: "post",
      data: {
        ...data,
        communityId,
      },
    })
      .then((response) => {
        const res = response.data;
        if (res.code === 0) {
          resolve(res);
        } else {
          reject(new Error(res.msg || "修改资金支付失败"));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 删除资金支付
export function deleteFundPayment(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId();
    request({
      url: "/fee.deleteFundPaymentCmd",
      method: "post",
      data: {
        ...data,
        communityId,
      },
    })
      .then((response) => {
        const res = response.data;
        if (res.code === 0) {
          resolve(res);
        } else {
          reject(new Error(res.msg || "删除资金支付失败"));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 导出资金支付（返回blob）
export function exportData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function importFundPayments(formData) {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/upload/assetImport/importData',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}